import { useMemo } from 'react';

import { useGetFeaturesConfigurationQuery } from '@fly/store';

export const useFeaturesConfiguration = () => {
  const query = useGetFeaturesConfigurationQuery();
  const distributionPackages = useMemo(
    () => query.data?.distribution?.packages ?? [],
    [query.data]
  );
  return {
    ...query,
    distributionPackages,
  };
};
